import React from "react"
import { appTools, cn } from "lib/utils"

export default function Textarea({ 
  children, 
  className, 
  error=null,
  ...rest
}:{ 
  className?:string
  error?:any
  [key:string]:any 
}){

  return (
    <textarea 
      className={cn(
        "w-full min-h-12 border border-solid border-slate-700 rounded-sm flex flex-row justify-start items-start bg-slate-900 outline-transparent outline outline-offset-2 text-sm text-gray-200 px-2 py-1 placeholder:opacity-40 placeholder:italic", 
        error && "outline-red-700",
        rest.readOnly && "cursor-not-allowed",
        className
      )} 
      {...rest} 
    />
  )
}